import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { queryClient } from './lib/queryClient';
import { AuthProvider } from './lib/auth-context';
import { ErrorBoundary, reloadOnceForChunkError } from './components/ErrorBoundary';
import { NewVersionBanner } from './components/NewVersionBanner';
import './lib/install-as';
import './index.css';

/**
 * ⭐`lib/install-as` 를 **여기서** 불러오는 이유 (v2.188.0).
 * 그 파일이 불려오는 즉시 브라우저의 설치 신호(`beforeinstallprompt`)에 귀를 연다. 그 사건은
 * 페이지를 연 직후 **한 번** 던져지고 끝이라, React 가 화면을 그린 뒤에 열면 이미 지나가 버린다.
 * ⛔쓰지 않는 것처럼 보여도 이 줄을 지우지 말 것 — 지우면 [📲 앱으로 설치] 단추가 영영 안 뜬다.
 * (아이폰 아이콘·이름 교체는 `index.html` 머리글 스크립트가 HTML 읽는 도중에 이미 끝낸다.)
 */

// PWA service worker 는 vite-plugin-pwa 가 injectRegister='auto' 로 자동 등록 (vite.config.ts 참조).
// 새 빌드 배포 시 다음 페이지 새로고침에서 SW 자동 갱신.

// 배포로 청크(JS 파일)가 바뀐 뒤 옛 탭이 사라진 파일을 동적 로드하려다 실패하면
// Vite 가 window 에 'vite:preloadError' 를 발생 → 자동 새로고침 1회로 최신 빌드 수신 (가드).
window.addEventListener('vite:preloadError', (e) => {
  const reloaded = reloadOnceForChunkError();
  // 새로고침을 실행할 거면 기본 동작(throw) 막아 콘솔 에러 억제.
  if (reloaded) e.preventDefault();
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <ErrorBoundary>
            {/* 🔄 새 버전 띠(v2.226.0) — 로그인 화면 · 포털 · 폰 앱 어디서나 */}
            <NewVersionBanner />
            <App />
          </ErrorBoundary>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
